import { calcularQtdDependentesConjuge } from "./funcoesAuxiliaresZUP";

export class CorrenteEdicaoZUP {
    constructor(
        dependentes,
        parentesco,
        categorias,
        valoresForm,
        valoresAnterioresForm
    ) {
        //CPF: ""
        // Categoria: ""
        // DepSexo: ""
        // Email: ""
        // Idade: ""
        // Nascimento: ""
        // Nome: ""
        // Parentesco: ""
        // Telefone: ""
        this.dependentes = dependentes;
        this.parentesco = parentesco;
        this.categorias = categorias;
        this.arrayMsgsErro = [];
        this.valoresForm = valoresForm;
        this.valoresAnterioresForm = valoresAnterioresForm;
    }
    infringeConjugue() {
        const qtdDependentesConjugue = calcularQtdDependentesConjuge(this.dependentes);
        if (qtdDependentesConjugue === 1 &&
             this.valoresAnterioresForm.Parentesco.trim() !== '10' &&
             this.valoresForm.Parentesco.trim() === '10') {
               
            this.arrayMsgsErro.push('Este plano permite apenas 1 dependente do tipo cônjuge.')
        }
        return this;
        
    }
    infringeValorAdicionalConjugeQuandoJaCadastrado() {
        const qtdDependentesConjugue = calcularQtdDependentesConjuge(this.dependentes);
        if (qtdDependentesConjugue === 1 &&
             this.valoresForm.Parentesco.trim() === '10' &&
             this.valoresForm.Categoria.trim() !== 'ZELO') {
            this.arrayMsgsErro.push('Este plano permite apenas cônjuge sem valor adicional.')
        }
        return this;
        
    }
    infringeConjugueQuandoNaoCadastrado() {
        const qtdDependentesConjugue = calcularQtdDependentesConjuge(this.dependentes);
        if (qtdDependentesConjugue === 0 &&
            this.valoresForm.Parentesco.trim() === '10' &&
            this.valoresForm.Categoria.trim() !== 'ZELO') {
            this.arrayMsgsErro.push('Este plano permite apenas cônjuge sem valor adicional.')
        }
        return this;
        
    }
    infringeValorAdicionalQuando18anos() {
        if (
            (this.valoresForm.Idade <=18 &&
                this.valoresForm.Idade !== '')  &&
                this.valoresForm.Categoria.trim() !== 'ZUP18' &&
                this.valoresForm.Parentesco.trim() !== '10') {
            this.arrayMsgsErro.push('Para dependentes até 18 anos, o adicional permitido é o PLENO ATÉ 18 ANOS.')
        }
        return this;
        
    }
    infringeValorAdicionalQuandoMaior18anosMenor64() {
        if (
            (this.valoresForm.Idade > 18 && this.valoresForm.Idade < 64) &&
         this.valoresForm.Categoria.trim() !== 'ZUP64' &&
         this.valoresForm.Parentesco.trim() !== '10') {
            this.arrayMsgsErro.push('Para dependentes entre 19 e 64 anos, o adicional permitido é o PLENO ATÉ 64 ANOS.')
        }
        return this
        
    }
    infringeValorAdicionalQuandoMaior65() {
        if (this.valoresForm.Idade >= 65 &&
            this.valoresForm.Categoria.trim() !== 'ZUP65' &&
            this.valoresForm.Parentesco.trim() !== '10' ) {
           this.arrayMsgsErro.push('Para dependentes acima de 65 anos, o adicional permitido é o PLENO MAIOR 65 ANOS.')
       }
        return this
        
    }
}
